module.exports = __webpack_public_path__ + "static/media/search_slider_phone2.3943afc0.png";